(function () {
    'use strict';
  
    angular.module('app.forms')
      .directive('formComponentDateslider', [function () {
        return {
          restrict: 'E',
          templateUrl: 'form-component-dateslider',
          replace: true,
          scope: {
            formattedDate: '=ngModel',
            opened: '=',
            defaultPlaceholder: '=',
            formObj: '=',
            formScope: '=',
            datesliderName: '=',
            isRequired: '=?',
            futureOnly: '=?',
            pastOnly: '=?',
            pastAndFuture: '=?',
            mode: '=?',
            includeDates: '=?',
            changeFunction: '=?',
            allowToday: "=?",
          },
          bindToController: true,
          controllerAs: 'vm',
          link: function () {},
          controller: ['$scope', '$filter', '$element', '$timeout', 'slickConfigService', function ($scope, $filter, $element, $timeout, slickConfigService) {
            var self = this;
            var minDate;
            var maxDate;
  
            if (typeof self.changeFunction === 'undefined') {
              self.changeFunction = function () {};
            }

            self.dt = new Date();

            if (typeof self.changeFunction === 'function') {
                self.changeFunction(self.dt);
            }
  
            self.dateOptions = {
              showWeeks: false,
              dateDisabled: function (data) {
                if (data.mode !== 'day' || !self.includeDates) {
                  return false;
                }

                return !_.contains(self.includeDates, data.date.getDay().toString());
              }
            };
  
            this.slickDates = slickConfigService.baseConfig(3);
  
            this.slickDates.slidesToScroll = 1;
            this.slickDates.arrows = false;
            this.slickDates.focusOnSelect = false;
            this.slickDates.draggable = true;
            this.slickDates.swipe = true;
            this.slickDates.touchMove = true;
            this.slickDates.infinite = false;

            self.slickPrev = function () {
              $element.find('.date-cards').slick('slickPrev');
            };
        
            self.slickNext = function () {
                $element.find('.date-cards').slick('slickNext');
            };

            this.advanceDate = function ($event) {
              var target = $event.currentTarget;
              var selectedDate = target.getAttribute('data-date');
              self.dt = selectedDate;
          
              angular.element(target).addClass('active');
              angular.element(target).siblings().removeClass('active');
          
              var dateParts = selectedDate.split('-'); 
              var dateObject = new Date(Date.UTC(dateParts[0], dateParts[1] - 1, dateParts[2]));
              var localDate = new Date(dateObject.getTime() + dateObject.getTimezoneOffset() * 60000);
          
              if (typeof self.changeFunction === 'function') {
                  self.changeFunction(localDate);
              }
          };
  
            // Set required to true by default, but allow for conditional or false
            if (typeof self.isRequired === 'undefined') {
              self.isRequired = true;
            }
  
            if (typeof self.mode !== 'undefined') {
              self.dateOptions.datesliderMode = self.mode;
            }
  
            // Format the date selection and make it available
            $scope.$watch(function () {
              return self.dt;
            }, function (value) {
              self.formattedDate = $filter('date')(value, 'MM/dd/yy');
            });
  
            if (typeof self.pastOnly === 'undefined') {
              self.pastOnly = false;
            }
  
            if (typeof self.pastAndFuture === 'undefined') {
              self.pastAndFuture = false;
            }
  
            if (typeof self.futureOnly === 'undefined' && !self.pastOnly && !self.pastAndFuture) {
              self.futureOnly = true;
            }
  
            if (typeof self.testing === 'undefined') {
              self.testing = false;
            }
  
            if (self.futureOnly) {
              // Enabled future only selections
              minDate = new Date();
              maxDate = new Date();
  
              if (!self.allowToday) {
                minDate.setDate(minDate.getDate() + 1);
              }
  
              maxDate.setDate(minDate.getDate() + 14);
  
              self.dateOptions.minDate = minDate;
              self.dateOptions.maxDate = maxDate;
            }
  
            if (self.pastOnly) {
              // Enabled past only selections
              maxDate = new Date();
              maxDate.setDate(maxDate.getDate() + 1);
  
              self.dateOptions.maxDate = maxDate;
            }
  
            $scope.$watch(() => self.allowToday, function (newValue) {
              if (newValue) {
                self.dateOptions.minDate = new Date();
              }
            });
  
            // Generate a list of dates between minDate and maxDate
self.generateDates = function () {
  const validDates = [];
  let currentDate = new Date();

  if (!self.allowToday) {
    currentDate.setDate(currentDate.getDate() + 1);
  }

  while (validDates.length < 14) {
    const dateCopy = new Date(currentDate);
    const dayIndex = dateCopy.getDay();

    const hasTours =
      self.formScope &&
      self.formScope.tourTimes &&
      Array.isArray(self.formScope.tourTimes[dayIndex]) &&
      self.formScope.tourTimes[dayIndex].length > 0;

    if (hasTours) {
      validDates.push(new Date(dateCopy));
    }

    currentDate.setDate(currentDate.getDate() + 1);
  }

  return validDates;
};

            self.generatedDates = self.generateDates();
  
            if (self.generatedDates.length > 0) {
              self.dt = self.generatedDates[0];
              if (typeof self.changeFunction === 'function') {
                self.changeFunction(self.dt);
              }
            }
  
            self.open = function (event) {
              event.preventDefault();
              event.stopPropagation();
              self.opened = true;
            };
  
            self.clear = function () {
              self.ngModel = null;
            };
          }]
        };
      }]);
  }());